import axios from 'axios';

const BASE_URL = process.env.VUE_APP_API_BASE_URL + '/tenant';
const SELECT_TOKEN = 'ur_select_token';
const SELECT_PROJECT = 'ur_select_project';
const SELECT_INTRO = 'ur_select_intro_shown';   // 進場提示旗標（每次登入重置 → 一次登入只彈一次）

// 前台專屬實例：比照 authRequest 的 URL 構造，但改用 landowner token、不掛 CRM 401 refresh
const selectRequest = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json', accept: 'application/json' },
});

selectRequest.interceptors.request.use(function (config) {
  const tenant = window.localStorage.getItem('tenant');
  const requestURL = config.url.charAt(0) === '/' ? config.url.slice(1) : config.url;
  config.url = config.url.includes('api') ? config.url : `/${tenant}/api/${requestURL}`;
  const token = window.localStorage.getItem(SELECT_TOKEN);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

class UrbanRenewalSelectService {
  getToken() { return window.localStorage.getItem(SELECT_TOKEN); }

  setSession(data) {
    window.localStorage.setItem(SELECT_TOKEN, data.token);
    window.localStorage.setItem(SELECT_PROJECT, JSON.stringify({
      project_id: data.project_id,
      project_name: data.project_name,
      selection_start: data.selection_start,
      selection_deadline: data.selection_deadline,
    }));
    window.localStorage.removeItem(SELECT_INTRO);   // 每次登入重置：本次登入首進主畫面會再彈一次進場提示
  }

  introShown() { return !!window.localStorage.getItem(SELECT_INTRO); }
  markIntroShown() { window.localStorage.setItem(SELECT_INTRO, '1'); }

  getProject() {
    try { return JSON.parse(window.localStorage.getItem(SELECT_PROJECT)) || null; }
    catch (e) { return null; }
  }

  clearSession() {
    window.localStorage.removeItem(SELECT_TOKEN);
    window.localStorage.removeItem(SELECT_PROJECT);
    window.localStorage.removeItem(SELECT_INTRO);
  }

  login(payload)             { return selectRequest.post('urbanrenewal/select/login/', payload); }
  forgotPassword(username)   { return selectRequest.post('urbanrenewal/select/forgot/', { username }); }
  resetPassword(token, password) { return selectRequest.post('urbanrenewal/select/reset/', { token, password }); }
  getMe()                    { return selectRequest.get('urbanrenewal/select/me/'); }
  getGrid()                  { return selectRequest.get('urbanrenewal/select/grid/'); }
  getDraft()                 { return selectRequest.get('urbanrenewal/select/draft/'); }
  saveDraft(payload)         { return selectRequest.post('urbanrenewal/select/draft/', payload); }
  exportSelection()          { return selectRequest.get('urbanrenewal/select/export/', { responseType: 'blob' }); }
}

export default new UrbanRenewalSelectService();
